import { useDispatch, useSelector } from "react-redux"
import * as authAction from '../../../../redux/auth/action'

export const useLogout = () => {
    const dispatch = useDispatch();
    const isLoading = useSelector((state: IAuthState) => state.auth.loading);

    const dispatchLogout = () => {
        dispatch(authAction.userLogoutGoogle())
    }

    return {
        dispatch,
        isLoading,
        dispatchLogout
    }
}